import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const SearchIcon = memo(({ style, className }: SVGProps) => {
  return (
    <svg style={style} className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m23.663 21.977-4.45-4.417a10.808 10.808 0 0 0-1.216-14.802 10.788 10.788 0 0 0-14.836.406 10.808 10.808 0 0 0-.406 14.847 10.788 10.788 0 0 0 14.792 1.217l4.413 4.417a1.199 1.199 0 0 0 1.703 0 1.2 1.2 0 0 0 0-1.668zm-12.844-2.749c-4.637 0-8.395-3.761-8.395-8.401s3.758-8.402 8.395-8.402c4.636 0 8.395 3.762 8.395 8.402a8.405 8.405 0 0 1-2.46 5.94 8.392 8.392 0 0 1-5.935 2.461z"
        fillRule="evenodd"
      />
    </svg>
  )
})
